import { Component, Inject, OnInit, ViewChild , EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_554';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: '¿Usted retiró ahorros de cuentas AFC, FVP o AVC, sin cumplir las condiciones de permanencia y destinación y cuyos aportes fueron originados en rentas no laborales?', listHelp: ['503'] },
  { text: "2", active: false, completed: false, tooltip: 'Indique el valor total de lo retirado ', listHelp: ['504'] },
  { text: "3", active: false, completed: false, tooltip: 'Indique  el valor de los aportes obligatorios a salud por sus ingresos de rentas no laborales', listHelp: ['508'] },
  { text: "4", active: false, completed: false, tooltip: 'Indique  el valor de los aportes obligatorios a fondos de pensiones y solidaridad pensional por sus ingresos de rentas no laborales', listHelp: ['509'] },
  { text: "5", active: false, completed: false, tooltip: 'Indique el valor total de su cotización voluntaria al Régimen de Ahorro Individual con Solidaridad (RAIS) por ingresos de rentas no laborales durante 2022', listHelp: ['510'] },
  { text: "6", active: false, completed: false, tooltip: 'Indique  el valor de los costos y gastos que va a incluir', listHelp: ['512'] },
  { text: "7", active: false, completed: false, tooltip: '¿Usted  tuvo rentas pasivas de ECE (Entidades Controladas del Exterior)?', listHelp: ['513'] },
  { text: "8", active: false, completed: false, tooltip: 'Indique el valor', listHelp: ['514'] },
  { text: "9", active: false, completed: false, tooltip: 'Si usted  hizo aportes voluntarios a pensión, cuentas AFC o AVC, indique su valor total', listHelp: ['515'] },
  { text: "10", active: false, completed: false, tooltip: 'Si usted recibió pagos por rentas no laborales en Ecuador, Perú o Bolivia (Comunidad Andina), por favor indique su valor total.', listHelp: ['517'] },
  { text: "11", active: false, completed: false, tooltip: 'Indique  las otras rentas exentas a las que tenga derecho de acuerdo con la normativa vigente', listHelp: ['518'] },
  { text: "12", active: false, completed: false, tooltip: 'Si usted  pagó intereses por préstamos para comprar vivienda, indique su valor total', listHelp: ['519'] },
  { text: "13", active: false, completed: false, tooltip: 'Si usted  pagó intereses al ICETEX por préstamos educativos, indique su valor total', listHelp: ['521'] },
  { text: "14", active: false, completed: false, tooltip: 'Si usted hizo aportes voluntarios a fondos de cesantías, indique su valor total', listHelp: ['526'] },
  { text: "15", active: false, completed: false, tooltip: 'Indique el valor total del 4 X 1000 según certificado tributario emitido por su entidad financiera (Gravamen a los Movimientos Financieros) ', listHelp: ['524'] },
  { text: "16", active: false, completed: false, tooltip: 'Si usted donó para investigación o desarrollo tecnológico a universidades o al ICETEX, indique el valor donado', listHelp: ['523'] },
  { text: "17", active: false, completed: false, tooltip: 'Entre 2019 y 2021 ¿tuvo pérdidas declaradas por rentas no laborales, que quiera compensar?', listHelp: ['528'] },
  { text: "18", active: false, completed: false, tooltip: 'Indique el valor de las pérdidas a compensar.', listHelp: ['529'] }
];

@Component({
  selector: 'app-renta-no-laboral-ingresos-anteriores-modal',
  templateUrl: './renta-no-laboral-ingresos-anteriores-modal.component.html',
  styleUrls: ['./renta-no-laboral-ingresos-anteriores-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class RentaNoLaboralIngresosAnterioresModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dialogRef: MatDialogRef<RentaNoLaboralIngresosAnterioresModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_503 == undefined)this.model.doc.cuerpo.cs_id_503=null;
    if(this.model.doc.cuerpo.cs_id_504 == undefined)this.model.doc.cuerpo.cs_id_504="0";
    if(this.model.doc.cuerpo.cs_id_508 == undefined)this.model.doc.cuerpo.cs_id_508="0";
    if(this.model.doc.cuerpo.cs_id_509 == undefined)this.model.doc.cuerpo.cs_id_509="0";  
    if(this.model.doc.cuerpo.cs_id_510 == undefined)this.model.doc.cuerpo.cs_id_510="0";
    if(this.model.doc.cuerpo.cs_id_511 == undefined)this.model.doc.cuerpo.cs_id_511="0";
    if(this.model.doc.cuerpo.cs_id_512 == undefined)this.model.doc.cuerpo.cs_id_512="0";
    if(this.model.doc.cuerpo.cs_id_513 == undefined)this.model.doc.cuerpo.cs_id_513=null;
    if(this.model.doc.cuerpo.cs_id_514 == undefined)this.model.doc.cuerpo.cs_id_514="0";
    if(this.model.doc.cuerpo.cs_id_515 == undefined)this.model.doc.cuerpo.cs_id_515="0";
    if(this.model.doc.cuerpo.cs_id_516 == undefined)this.model.doc.cuerpo.cs_id_516="0";
    if(this.model.doc.cuerpo.cs_id_517 == undefined)this.model.doc.cuerpo.cs_id_517="0";  
    if(this.model.doc.cuerpo.cs_id_518 == undefined)this.model.doc.cuerpo.cs_id_518="0";
    if(this.model.doc.cuerpo.cs_id_519 == undefined)this.model.doc.cuerpo.cs_id_519="0";
    if(this.model.doc.cuerpo.cs_id_520 == undefined)this.model.doc.cuerpo.cs_id_520="0";
    if(this.model.doc.cuerpo.cs_id_521 == undefined)this.model.doc.cuerpo.cs_id_521="0";
    if(this.model.doc.cuerpo.cs_id_522 == undefined)this.model.doc.cuerpo.cs_id_522="0";
    if(this.model.doc.cuerpo.cs_id_526 == undefined)this.model.doc.cuerpo.cs_id_526="0";
    if(this.model.doc.cuerpo.cs_id_527 == undefined)this.model.doc.cuerpo.cs_id_527="0";
    if(this.model.doc.cuerpo.cs_id_523 == undefined)this.model.doc.cuerpo.cs_id_523="0";
    if(this.model.doc.cuerpo.cs_id_524 == undefined)this.model.doc.cuerpo.cs_id_524="0";
    if(this.model.doc.cuerpo.cs_id_525 == undefined)this.model.doc.cuerpo.cs_id_525="0";  
    if(this.model.doc.cuerpo.cs_id_528 == undefined)this.model.doc.cuerpo.cs_id_528=null;  
    if(this.model.doc.cuerpo.cs_id_529 == undefined)this.model.doc.cuerpo.cs_id_529="0";
    if(this.model.doc.cuerpo.cs_id_554 == undefined)this.model.doc.cuerpo.cs_id_554="0";
    



    
    
  }

  //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
    switch (this.indexStepper) {
      case 0:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_503 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_503 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_503 = val;
        }
        this.buttonRight.nativeElement.disabled = true;

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 6:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_513 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_513 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_513 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 16:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_528 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_528 = val;
          }
          this.validateShowSave();
        }else{
          this.model.doc.cuerpo.cs_id_528 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!="" && val!="0"){
          this.buttonRight.nativeElement.disabled = false;
        }
        if(val == "0"){
          this.buttonRight.nativeElement.disabled = true;
          this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
        }
        console.log( this.buttonRight.nativeElement.disabled )
        break;

      
    
   }
    console.log(this.model);
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){//Pregunta Actualizar 
      case 0:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_504, "0")){
          hasValues=true;
        }

        break;
     case 6:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_514, "0")){
          hasValues=true;
        }
        break;
       case 16:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_529, "0")){
          hasValues=true;
        }
        break; 
    }
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0:
        this.model.doc.cuerpo.cs_id_504="0";
       case 6:
        this.model.doc.cuerpo.cs_id_514="0";
        break;
      case 16:
        this.model.doc.cuerpo.cs_id_529="0";
        break; 
      default:
        break;
    }
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    //Si no ha respondido en rn102RentaNoLaboral no puede saltar preguntas
    if( (indexS>=0 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_503==undefined || this.model.doc.cuerpo.cs_id_503=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en rn102RentaNoLaboral debe saltar preguntas del indexStepper
    else if( (indexS==1 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_503=="0")) ){
      habilitado = false;
    }
     //Si no ha respondido en go16CasaAFC no puede saltar preguntas
     if( (indexS>=7 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_513==undefined || this.model.doc.cuerpo.cs_id_513=="")) ){
      habilitado = false;
    }
  
    //Si responde 'NO' en go16CasaAFC debe saltar preguntas del indexStepper
    else if( (indexS==7 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_513=="0")) ){
      habilitado = false;
    } 
    
    //Si no ha respondido en rn1017RentaNoLaboral no puede saltar preguntas
    if( (indexS>=17 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_528==undefined || this.model.doc.cuerpo.cs_id_528=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en rn1017RentaNoLaboral debe saltar preguntas del indexStepper
    else if( (indexS==17 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_528=="0")) ){
      habilitado = false;
    } 
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
    //Si no se ha seleccionado respuesta SI/NO en rn102RentaNoLaboral deshabilitar botón next
    switch(this.indexStepper){
      case 0:
        //Si no se ha seleccionado respuesta SI/NO en rn102RentaNoLaboral deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_503==undefined || this.model.doc.cuerpo.cs_id_503=="" ||  this.model.doc.cuerpo.cs_id_503 == null){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
 
      case 6:
        //Si no se ha seleccionado respuesta SI/NO en rn1019RentaNoLaboral deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_513==undefined || this.model.doc.cuerpo.cs_id_513=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
       case 16:
        //Si no se ha seleccionado respuesta SI/NO en rn1017RentaNoLaboral deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_528==undefined || this.model.doc.cuerpo.cs_id_528==""  || this.model.doc.cuerpo.cs_id_528=="0" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break; 
      default:
        if (this.indexStepper === stepsList.length - 1) {
          this.buttonRight.nativeElement.disabled = true;
        } else {
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
    }
  }
  


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
  this.validateShowSave();
  }
  
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 479:
        this.OperacionCs504();
        break;
        
      case 503:
        this.OperacionCs503();
        break;

        case 504:
        this.OperacionCs504();
        break;

        case 508:
        this.OperacionCs508();
        break;

        case 509:
        this.OperacionCs509();
        break;

        case 510:
        this.OperacionCs510();
        break;
        
        
        case 511:
        this.OperacionCs511();
        break;
        
        case 512:
        this.OperacionCs512();
        break;
        
        case 513:
        this.OperacionCs513();
        break;
        
        case 514:
        this.OperacionCs514();
        break;
        
        case 516:
        this.OperacionCs516();
        break;
        
        case 517:
        this.OperacionCs517();
        break;
        
        
        case 518:
        this.OperacionCs518();
        break;
        
        case 519:
        this.OperacionCs519();
        break;
        
        case 520:
        this.OperacionCs520();
        break;
        
        case 522:
        this.OperacionCs522();
        break;

        case 523:
        this.OperacionCs523();
        break;
        
        case 524:
        this.OperacionCs524();
        break;
        
        case 525:
        this.OperacionCs525();
        break;
        
        case 526:
        this.OperacionCs526();
        break;

        case 527    :
        this.OperacionCs527();
        break;

        case 528:
        this.OperacionCs528();
        break;

        case 529:
        this.OperacionCs529();
        break;
        
        

             
   }
   if(soloEstaCasilla)return;

   
   let resultado = "0";
  }

  
   
 //retiro ahorros de cuentas AFC
 OperacionCs503(){
	const cas503 = this.model.doc.cuerpo.cs_id_503;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas503,"0")) {
		this.model.doc.cuerpo.cs_id_504="0";
	}
}

//valor retirado cuentas AFC..
OperacionCs504() {
const 	cas504 = this.model.doc.cuerpo.cs_id_504
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas504,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Los retiros no pueden ser cero");
      return
   }
 }
 
 //aportes a salud
OperacionCs508() {
	//no tiene validaciones
}

//aportes a pension
OperacionCs509() {
	//no tiene validaciones
}

//cotizacion voluntaria RAIS
OperacionCs510() {
	this.OperacionCs511();
}


//Limitante cotizacion voluntaria RAIS
OperacionCs511() {
	//Valor se calcula en recalculo casillas 210
}

//Costos y gastos
OperacionCs512() {
	//no tiene validaciones
}

//rentas pasivas ECE ?
 OperacionCs513(){
	const cas513 = this.model.doc.cuerpo.cs_id_513;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas513,"0")) {
		this.model.doc.cuerpo.cs_id_514="0";
	}
}

// Valor rentas pasivas ECE
OperacionCs514() {
	const cas514 = this.model.doc.cuerpo.cs_id_514;
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas514,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Las rentas pasivas de ECE no pueden ser cero");
      return
   }
 }


//aportes voluntarios cuentas AFC...
OperacionCs515() {
	//no tiene validaciones
	this.OperacionCs516();
}

//Limitante aportes voluntarios...
OperacionCs516() {
  //Valor se calcula en recalculo casillas 210
}

//ingresos CAN
OperacionCs517() {
	const cas517 = this.model.doc.cuerpo.cs_id_517;
	
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas517,"0")) {
	   
	   	const datosSuma = ['cs_id_479','cs_id_480','cs_id_482','cs_id_483','cs_id_488','cs_id_492','cs_id_495','cs_id_497','cs_id_499','cs_id_501','cs_id_804','cs_id_714','cs_id_664','cs_id_742'];
	    const suma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA,this.model, datosSuma, true);
	    
	   
	   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas517,suma)) {
			this.dNotificacionServicio.mostrarDialogoInformacion("El valor reportado no puede ser mayor que sus ingresos recibidos");
			this.model.doc.cuerpo.cs_id_517="0";
	   }		
	}
}

OperacionCs518() {
	//no tiene validaciones
}

//intereses prestamos de vivienda
OperacionCs519(){
	const cas519 = this.model.doc.cuerpo.cs_id_519;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas519,"0")) {
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas258 = this.model.doc.cuerpo.cs_id_258;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas258,"0")) {
			this.model.doc.cuerpo.cs_id_519="0";
			this.model.doc.cuerpo.cs_id_520="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}

		const cas291 = this.model.doc.cuerpo.cs_id_291;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas291,"0")) {
			this.model.doc.cuerpo.cs_id_519="0";
			this.model.doc.cuerpo.cs_id_520="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
			return
		}
		
		const cas325 = this.model.doc.cuerpo.cs_id_325;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas325,"0")) {
			this.model.doc.cuerpo.cs_id_519="0";
			this.model.doc.cuerpo.cs_id_520="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
			return
		}
		
		const cas412 = this.model.doc.cuerpo.cs_id_412;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas412,"0")) {
			this.model.doc.cuerpo.cs_id_519="0";
			this.model.doc.cuerpo.cs_id_520="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		

	}
	
	this.OperacionCs520();
}

//limitante intereses prestamos de vivienda
OperacionCs520(){
	const cas519 = this.model.doc.cuerpo.cs_id_519;
	const uvt1200 = "45605000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas519,uvt1200)) {
		this.model.doc.cuerpo.cs_id_520 = cas519;
	} else {
		this.model.doc.cuerpo.cs_id_520 = uvt1200;
	}
}


//intereses icetex
OperacionCs521(){
	const cas521 = this.model.doc.cuerpo.cs_id_521;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas521,"0")) {
		
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas260 = this.model.doc.cuerpo.cs_id_260;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas260,"0")) {
			this.model.doc.cuerpo.cs_id_521="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como asalariado");
			return
		}
	
		const cas293 = this.model.doc.cuerpo.cs_id_293;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas293,"0")) {
			this.model.doc.cuerpo.cs_id_521="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
			return
		}
		
		const cas327 = this.model.doc.cuerpo.cs_id_327;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas327,"0")) {
			this.model.doc.cuerpo.cs_id_521="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
			return
		}
		
		const cas414 = this.model.doc.cuerpo.cs_id_414;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas414,"0")) {
			this.model.doc.cuerpo.cs_id_521="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		

	}
	
	this.OperacionCs522();
}

//limitante intereses icetex
OperacionCs522(){
	const cas521 = this.model.doc.cuerpo.cs_id_521;
	const uvt100 = "3800000"
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas521,uvt100)) {
		this.model.doc.cuerpo.cs_id_522 = cas521;
	} else {
		this.model.doc.cuerpo.cs_id_522 = uvt100;
	}
}

// aportes voluntarios a cesantias..
OperacionCs526(){
	// no tiene validaciones
	this.OperacionCs527;
}

//limitante aportes voluntarios cesantias
OperacionCs527(){
	//Valor se calcula en recalculo casillas 210
}


//donacion para investigacion
OperacionCs523(){
	
	const cas523 = this.model.doc.cuerpo.cs_id_523;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas523,"0")) {
		
		//si ya esta diligenciada en otra renta entonces colocar en cero
		const cas271 = this.model.doc.cuerpo.cs_id_271;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas271,"0")) {
			this.model.doc.cuerpo.cs_id_523="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("reportó por esta deducción en las rentas de trabajado para asalariado");
			return
		}

		const cas303 = this.model.doc.cuerpo.cs_id_303;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas303,"0")) {
			this.model.doc.cuerpo.cs_id_523="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de trabajo como trabajador independiente");
			return
		}
		
		const cas337 = this.model.doc.cuerpo.cs_id_337;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas337,"0")) {
			this.model.doc.cuerpo.cs_id_523="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas por honorarios");
			return
		}
		
		const cas416 = this.model.doc.cuerpo.cs_id_416;
		if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas416,"0")) {
			this.model.doc.cuerpo.cs_id_523="0";
			this.dNotificacionServicio.mostrarDialogoInformacion("Ya reportó por esta deducción en las rentas de capital");
			return
		}
		

	}
}

// 4 X MIL
OperacionCs524(){
	this.OperacionCs525();
}

//Limitante 4 x mil
OperacionCs525(){
	const porcentajeTopeMax = "0.50";
	const cas524 = this.model.doc.cuerpo.cs_id_524;
	const resultado =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas524,porcentajeTopeMax);
	this.model.doc.cuerpo.cs_id_525 = this.dutilidades.redondearValorMoneda(resultado ,true);
}

//Pérdidas renta no laborales ?
OperacionCs528(){
	const cas528 = this.model.doc.cuerpo.cs_id_528;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas528,"0")) {
		this.model.doc.cuerpo.cs_id_529="0";
	}
}

//Valor pérdidas a compensar
OperacionCs529(){
	const cas529 = this.model.doc.cuerpo.cs_id_529;
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas529,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El valor de las pérdidas a compensar por rentas no laborales no puede ser cero");
      return
   }
	
   //Otras validaciones se realizan en el 210
}



  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO 
      || (this.indexStepper == 16 && this.model.doc.cuerpo.cs_id_528=="0")){ this.showSave=true };
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1 || (this.indexStepper == 16 && this.model.doc.cuerpo.cs_id_528=="0")){
      this.closeModal();
    }

    
  }

  protected operarCamposCuerpo(operacion: DTipoOperacionAritmetica, modelo: DDocumento, campos: Array<string>, formatear: boolean): string {                    
    let valores = [];
    for (let i in campos) {
        if (this.dutilidades.validarValorNumerico(modelo.doc.cuerpo[campos[i]])) {
            let valor = this.dutilidades.redondearValorMoneda(modelo.doc.cuerpo[campos[i]]);            
            valores.push(valor);
            //valores.push(modelo.doc.cuerpo[campos[i]]);
        } else {
            valores.push('0');
        }
    }
    return this.dutilidades.ejecutarOperacionMultipleValores(valores, operacion, formatear);
}

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-ingresos-anteriores-modal/renta-no-laboral-ingresos-anteriores-modal.component.ts